import { Countries } from '~globals/types/enums';

export const checkIsArg = (countryId?: Countries): boolean =>
  countryId === Countries.Argentina;
